/**
 * webRTC config file
 *
 * @authors Luo-jinghui (luojinghui424@gmail.com)
 * @date  2020-01-17 12:04:01
 */
export const SERVER = {
  wssServer: 'wss://cloudapi.xylink.com',
  httpServer: 'https://cloudapi.xylink.com',
  logServer: 'https://log.xylink.com',
};

// export const ACCOUNT = {
//   extId: '0142901e3d83e0a1e225ef92b8663fcaebda7242',
//   clientId: 'BR1e5cptJgyC1aFRtiXfmdg3',
//   clientSecret: 'I2aQ80XuXcrMTemfgwzm0zYvEyWpdqb0',
// };

export const ACCOUNT = {
  extId: '1542287a07bb305d8a16168803e473e2a4b1085b',
  clientId: 'D1flyqhnNZQgmIJnQEHCpvLD',
  clientSecret: 'pV94zT8j29KGl9bFFjBY9mg7CpX67OlO',
};
